module.exports = __webpack_public_path__ + "static/media/backWave13.a4918be7.svg";